import {Directive, ViewContainerRef} from '@angular/core';

@Directive({standalone: true, selector: '[pubLogo]'})
export class LogoDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
